import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function usePhoneCountries() {
  const [countries, setCountries] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.countries.phone_countries)
      .then((response) => {
        setCountries(response.data.data);
      });
  }, []);

  return countries;
}
